import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "../../../../components/Layout/Header/Header";
import Footer from "../../../../components/Layout/Footer/Footer";
import ScrollToTop from "../../../../components/Common/ScrollTop";
import OffWrap from "../../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../../components/Common/Breadcumb";
import SearchModal from "../../../../components/Layout/Header/SearchModal";
import footerLogo from "../../../../assets/img/logo/jntua-logo.png";
import { fetchData, imageBaseURL } from "../../../../utils/fetchData";
import Accreditation from "../../../../components/Common/Accreditation";
import pdf from "../../../../assets/img/pdf.png";
import { useFontSize } from "../../../../FontSizeContext";
import { getMenu, getAPIPath } from "../../../../utils/getDomainData";

const OTPRI_FeeStructure = () => {
  const [data, setData] = useState([]);
  let location = useLocation();
  const currentDomain = location.pathname.split("/")[1];
  const { fontSize } = useFontSize();

  useEffect(() => {
    fetchData(getAPIPath(currentDomain)?.feeStructure, setData);
  }, [currentDomain]);

  const feeData = data?.data?.attributes?.links || [];

  return (
    <React.Fragment>
      <Helmet>
        <title>Fee Structure | OTPRI | JNTU Anantapur</title>
        <meta
          name="description"
          content="Fee structure for pharmacy courses at Oil Technological & Pharmaceutical Research Institute, JNTUA"
        />
        <meta
          name="keywords"
          content="Fee Structure, B.Pharm, M.Pharm, Pharm.D, OTPRI, Pharmacy, JNTUA, Tuition Fees"
        ></meta>
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="home"
        TopBar="enable"
        TopBarClass="topbar-area dark-primary-bg hidden-lg"
      />
      <style>
        {`
                    body,
                    .rs-latest-events.style1 .event-wrap .events-short .date-part .date,
                    .widget ul li a {
                        font-size: ${fontSize}px;
                    }
                    .rs-inner-blog .blog-item .blog-content .blog-title,
                    .widget h1,.content-wrapper h2, .heading, .college-title{
                        font-size: calc(${fontSize}px + 10px);
                    }
                    .breadcrumb-bg .breadcrumbs-text ul li{
                      font-size: calc(${fontSize}px + 2px);
                    }
                    
                    .full-width-header .rs-header .topbar-area .topbar-right li.login-register a,
                    .readon.orange-btn, .rs-latest-events.bg-wrap .notification-filter button,
                    .rs-latest-events.style1 .event-wrap:not(.ls-area) .events-short .slNo, 
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > a,
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > ul li > a,
                    table th, table td {                       
                        font-size: calc(${fontSize}px - 2px);
                    }

                    .rs-footer .footer-top-social .social_msg{
                        font-size: calc(${fontSize}px + 18px);
                    }
                    .rs-footer .footer-center h3{
                        font-size: calc(${fontSize}px + 12px);
                    }
                    .rs-footer.home9-style .footer-top .widget-title,
                    .rs-team.style1 .about-btn--primary,
                    .rs-team.style1 .about-btn--secondary,
                    .course-overview .inner-box h5{
                        font-size: calc(${fontSize}px + 4px);
                    }
                    .rs-footer .footer-center h4,
                    .rightBar h4{
                        font-size: calc(${fontSize}px + 6px);
                    }

                    .fee-table-wrapper {
                        background: #fff;
                        border-radius: 8px;
                        box-shadow: 0 2px 10px rgba(0,123,255,0.1);
                        overflow-x: auto;
                        margin-bottom: 30px;
                    }

                    .fee-table {
                        margin-bottom: 0;
                        background: #fff;
                    }

                    .fee-table thead {
                        background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
                        color: white;
                    }

                    .fee-table thead th {
                        border: none;
                        font-weight: 600;
                        text-transform: uppercase;
                        letter-spacing: 0.5px;
                        padding: 18px 15px;
                        font-size: calc(${fontSize}px - 1px);
                        white-space: nowrap;
                        vertical-align: middle;
                    }

                    .fee-table tbody td {
                        padding: 15px;
                        vertical-align: middle;
                        border-color: #e3f2fd;
                    }

                    .course-name-cell {
                        font-weight: 600;
                        color: #007bff;
                        font-size: calc(${fontSize}px + 1px);
                        min-width: 250px;
                    }

                    .pdf-link-cell {
                        min-width: 200px;
                    }

                    .pdf-link {
                        display: inline-flex;
                        align-items: center;
                        gap: 8px;
                        text-decoration: none;
                        color: #007bff;
                        transition: all 0.3s ease;
                        padding: 8px 15px;
                        border-radius: 6px;
                        background: #e3f2fd;
                        font-weight: 500;
                    }

                    .pdf-link:hover {
                        background: #007bff;
                        color: white;
                        transform: translateX(3px);
                        box-shadow: 0 2px 8px rgba(0,123,255,0.3);
                    }

                    .pdf-link img {
                        width: 24px;
                        height: 24px;
                    }

                    .no-data-cell {
                        text-align: center;
                        padding: 60px 20px;
                        color: #999;
                    }

                    .no-data-cell i {
                        font-size: 60px;
                        color: #ddd;
                        margin-bottom: 20px;
                        display: block;
                    }

                    .no-data-cell h5 {
                        color: #666;
                        font-weight: 500;
                        margin-bottom: 10px;
                    }

                    @media (max-width: 768px) {
                        .fee-table {
                            font-size: calc(${fontSize}px - 2px);
                        }

                        .fee-table thead th,
                        .fee-table tbody td {
                            padding: 10px 8px;
                        }

                        .course-name-cell {
                            min-width: 200px;
                        }

                        .pdf-link-cell {
                            min-width: 150px;
                        }
                    }
                `}
      </style>
      <div className="pageTopOffset">
        {/* breadcrumb-area-start */}
        <SiteBreadcrumb
          pageTitle="Fee Structure"
          pageName="Fee Structure"
          breadcrumbsClass="breadcrumb-bg"
        />
        {/* breadcrumb-area-start */}
        {getMenu(currentDomain)}
        <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
          <div className="container">
            <div className="row">
              <div className="col pl-20 md-pl-14">
                <div className="row">
                  <div className="rs-inner-blog col-lg-12">
                    <h3 className="college-title text-center mb-5">
                      Fee Structure
                    </h3>
                    
                    <div className="fee-table-wrapper">
                      {feeData.length > 0 ? (
                        <table className="table table-striped table-bordered fee-table">
                          <thead>
                            <tr>
                              <th>S.No</th>
                              <th>Course / Program</th>
                              <th>Fee Details</th>
                            </tr>
                          </thead>
                          <tbody>
                            {feeData.map((item, index) => {
                              const pdfUrl = item?.content?.data?.attributes?.url;
                              const pdfName = item?.content?.data?.attributes?.name;
                              
                              return (
                                <tr key={item.id || index}>
                                  <td>{index + 1}</td>
                                  <td className="course-name-cell">
                                    {item.label || "N/A"}
                                  </td>
                                  <td className="pdf-link-cell">
                                    {pdfUrl ? (
                                      <a
                                        href={imageBaseURL + pdfUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="pdf-link"
                                        title={pdfName || item.label}
                                      >
                                        <img src={pdf} alt="PDF" />
                                        <span>View Fee Structure</span>
                                      </a>
                                    ) : (
                                      "N/A"
                                    )}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      ) : (
                        <div className="no-data-cell">
                          <i className="fas fa-file-invoice-dollar"></i>
                          <h5>No fee structure information available at the moment.</h5>
                          <p>Please check back later for fee details.</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Accreditation />

      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />

      {/* scrolltop-start */}
      <ScrollToTop scrollClassName="scrollup orange-color" />
      {/* scrolltop-end */}

      <SearchModal />
    </React.Fragment>
  );
};

export default OTPRI_FeeStructure;
